import { combineReducers } from 'redux'

import attributes from './attributes'
import filters from './filters'
import chart from './chart'
import ui from './ui'
import logs from './logs'

export default combineReducers({
  attributes,
  filters,
  chart,
  ui,
  logs,
})
